module.exports = __webpack_public_path__ + "static/img/GT@2x.05df294c.jpg";